import Transform from "@ember-data/serializer/transform";
import Vaccine from "core/models/vaccine";
export default class VaccinesTransform extends Transform {
  deserialize(serialized) {
    if (!(serialized instanceof Array)) return null;
    return serialized.map(r => {
      const vaccinationDate = r.vaccinationDate ? new Date(r.vaccinationDate) : undefined;
      return new Vaccine(r.name, r.done, vaccinationDate);
    });
  }
  serialize(deserialized) {
    if (deserialized == null) return null;
    return deserialized.map(r => r.serialize());
  }
}